/** @format */

import React from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import I18n from '../Translate/I18n';

import customInputStyle from 'assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

function CustomInputNumber({ ...props }) {
    const {
        classes,
        formControlProps,
        labelText,
        id,
        labelProps,
        inputProps,
        error,
        white,
        inputRootCustomClasses,
        success,
        helpText,
        onChange,
        onClick,
        name,
        value,
        required,
        decimalLimit,
        labelTextValue,
        onFocusHandler,
        onBlurHandler,
    } = props;

    const labelClasses = classNames({
        [' ' + classes.labelRootError]: error,
        [' ' + classes.labelRootSuccess]: success && !error,
    });
    const underlineClasses = classNames({
        [classes.underlineError]: error,
        [classes.underlineSuccess]: success && !error,
        [classes.underline]: true,
        [classes.whiteUnderline]: white,
    });
    const marginTop = classNames({
        [inputRootCustomClasses]: inputRootCustomClasses !== undefined,
    });
    const inputClasses = classNames({
        [classes.input]: true,
        [classes.whiteInput]: white,
    });
    let formControlClasses;
    if (formControlProps !== undefined) {
        formControlClasses = classNames(formControlProps.className, classes.formControl);
    } else {
        formControlClasses = classes.formControl;
    }
    const helpTextClasses = classNames({
        [classes.labelRootError]: error,
        [classes.labelRootSuccess]: success && !error,
    });

    const validate = (s) => {
        const limit = decimalLimit ? decimalLimit : 2;
        const rgxAsStr = `^[0-9]*\\.?[0-9]{0,${limit}}$`;
        const rgx = new RegExp(rgxAsStr);
        return s.match(rgx);
    };

    const onChangeHandler = (event) => {
        event.target.value = event.target.value.replace(',', '.');
        if (validate(event.target.value)) {
            onChange(event);
        }
    };

    return (
        <FormControl {...formControlProps} className={formControlClasses}>
            {labelText !== undefined ? (
                <InputLabel className={classes.labelRoot + ' ' + labelClasses} htmlFor={id} {...labelProps}>
                    {!labelTextValue && (required ? <I18n trans={labelText} asterisk={true} /> : <I18n trans={labelText} />)}
                    {labelTextValue &&
                        (required ? (
                            <I18n trans={labelText} asterisk={true} valueObject={labelTextValue} />
                        ) : (
                            <I18n trans={labelText} valueObject={labelTextValue} />
                        ))}
                </InputLabel>
            ) : null}
            <Input
                classes={{
                    input: inputClasses,
                    root: marginTop,
                    disabled: classes.disabled,
                    underline: underlineClasses,
                }}
                id={id}
                onChange={onChangeHandler}
                onFocus={onFocusHandler ?? null}
                onBlur={onBlurHandler ?? null}
                onClick={onClick}
                name={name}
                value={typeof value === 'undefined' ? '' : value}
                {...inputProps}
            />
            {helpText !== undefined ? (
                <FormHelperText id={id + '-text'} className={helpTextClasses}>
                    <I18n trans={helpText} />
                </FormHelperText>
            ) : null}
        </FormControl>
    );
}

CustomInputNumber.propTypes = {
    classes: PropTypes.object.isRequired,
    labelText: PropTypes.node,
    labelProps: PropTypes.object,
    id: PropTypes.string,
    inputProps: PropTypes.object,
    formControlProps: PropTypes.object,
    inputRootCustomClasses: PropTypes.string,
    error: PropTypes.bool,
    success: PropTypes.bool,
    white: PropTypes.bool,
    helpText: PropTypes.node,
    name: PropTypes.string,
    onClick: PropTypes.func,
    onFocusHandler: PropTypes.func,
    onBlurHandler: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default withStyles(oplAppStyle)(CustomInputNumber);
